import { render, staticRenderFns } from "./gc-popup-item-price-update.vue?vue&type=template&id=7afbf33a"
import script from "./gc-popup-item-price-update.vue?vue&type=script&lang=js"
export * from "./gc-popup-item-price-update.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-item-price-update.vue?vue&type=style&index=0&id=7afbf33a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports